import PropTypes from 'prop-types';
import React, { Fragment, Component } from 'react';
import { injectIntl } from 'react-intl';
import moment from 'moment';

import ButtonGroup from '@ontruck/ontruck-react-components/lib/ButtonGroup';
import Button from '@ontruck/ontruck-react-components/lib/Button';
import Input from '@ontruck/ontruck-react-components/lib/Input';
import Select from 'components/Select';
import { FormatPrice } from 'utils/format';
import { Modal, Flexer } from '@ontruck/orc';
import Calendar from 'components/Calendar';

import style from './style.module.scss';
import './style.scss';

import { Section, SectionTitle } from 'components/ModalFormLayout';

const requestDateFormat = 'YYYY-MM-DD';

class ContractModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    carrier: PropTypes.object,
    onClose: PropTypes.func,
    intl: PropTypes.any,
    onSave: PropTypes.func,
    onSaveSuccesfully: PropTypes.func,
    drivers: PropTypes.array,
    vehicles: PropTypes.array,
    contract: PropTypes.object,
    onUpdateExceptionsClick: PropTypes.func,
    onFinish: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      startDateModalOpened: false,
      endDateModalOpened: false,
      exceptionsModalOpened: false,
      finishContractModalOpened: false,
      driver: null,
      vehicle: null,
      end_date: null,
      start_date: moment(),
      cost_per_day: null,
      exceptions: props.contract && props.contract.exceptions,
      addedExceptions: [],
      fieldErrors: [],
      selectedDays: [],
      loading: false,
      finishDaySelected: null,
    };

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleStartDayClick = this.handleStartDayClick.bind(this);
    this.getStartDateValue = this.getStartDateValue.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.getEndDateValue = this.getEndDateValue.bind(this);
    this.handleEndDayClick = this.handleEndDayClick.bind(this);
    this.validate = this.validate.bind(this);
    this.handleSave = this.handleSave.bind(this);

    this.handleExceptionsDayClick = this.handleExceptionsDayClick.bind(this);
    this.handleUpdateExceptionsClick = this.handleUpdateExceptionsClick.bind(this);

    this.handleServerError = this.handleServerError.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.handleFinishContractDayClick = this.handleFinishContractDayClick.bind(this);
    this.handleFinishContractClick = this.handleFinishContractClick.bind(this);
  }

  handleStartDayClick(day, { disabled }) {
    if (disabled) {
      return;
    }
    this.setState({
      start_date: moment(day),
      startDateModalOpened: false,
    });
  }

  toggleModal(modal, opened) {
    return () => {
      const { contract } = this.props;
      this.setState({
        fieldErrors: [],
        addedExceptions: [],
        exceptions: (contract && contract.exceptions) || [],
        finishDaySelected: null,
        [modal]: opened,
      });
    };
  }

  getStartDateValue() {
    const { start_date } = this.state;

    const today = moment();
    const tomorrow = moment().add(1, 'days');
    const startDate = moment(start_date);

    if (startDate.isSame(today, 'day')) {
      return 'today';
    } else if (startDate.isSame(tomorrow, 'day')) {
      return 'tomorrow';
    }

    return 'other';
  }

  handleStartDateChange(value) {
    const dateValues = {
      today: () => moment(),
      tomorrow: () => moment().add(1, 'days'),
    };

    if (dateValues[value]) {
      this.setState({
        start_date: dateValues[value](),
      });
    } else {
      this.setState({
        startDateModalOpened: true,
      });
    }
  }

  handleEndDateChange(value) {
    if (value) {
      this.setState({
        endDateModalOpened: true,
      });
    } else {
      this.setState({
        end_date: null,
      });
    }
  }

  getEndDateValue() {
    const { end_date } = this.state;
    if (end_date === null) {
      return null;
    }
    return 'defined';
  }

  handleEndDayClick(day, { disabled }) {
    if (disabled) {
      return;
    }
    this.setState({
      end_date: moment(day),
      endDateModalOpened: false,
    });
  }

  handleFinishContractDayClick(day, { disabled }) {
    if (disabled) {
      return;
    }
    this.setState({
      finishDaySelected: day,
    });
  }

  handleFinishContractClick() {
    const { onFinish } = this.props;

    const { finishDaySelected } = this.state;

    onFinish(moment(finishDaySelected).format(requestDateFormat)).then(
      this.toggleModal('finishContractModalOpened', false)
    );
  }

  handleChange(key) {
    return (value) => {
      this.setState({
        fieldErrors: [],
        [key]: value.value || value,
      });
    };
  }

  validate() {
    const validations = {
      driver: (driver) => driver,
      vehicle: (vehicle) => vehicle,
      cost_per_day: (cost_per_day) => cost_per_day,
    };

    const fieldErrors = Object.keys(validations)
      .map((field) => (validations[field](this.state[field]) ? null : field))
      .filter((error) => error);

    return new Promise((resolve, reject) => {
      if (fieldErrors.length === 0) {
        resolve();
      } else {
        this.setState(
          {
            fieldErrors,
          },
          () => reject(fieldErrors)
        );
      }
    });
  }

  handleServerError(err) {
    if (!err) {
      return;
    }

    if (err.start_date && err.start_date.code) {
      const { fieldErrors } = this.state;

      this.setState({
        fieldErrors: [...fieldErrors, err.start_date.code],
      });
      return;
    }

    if (err.code && err.code.length) {
      const { fieldErrors } = this.state;

      this.setState({
        fieldErrors: [...fieldErrors, err.code[0]],
      });
      return;
    }
  }

  handleSave() {
    const { onSave, carrier, onSaveSuccesfully } = this.props;

    const { start_date, end_date, driver, vehicle, cost_per_day } = this.state;

    this.validate()
      .then(() =>
        this.setState(
          {
            loading: true,
          },
          () =>
            onSave({
              start_date: start_date.format(requestDateFormat),
              end_date: end_date ? end_date.format(requestDateFormat) : null,
              cost_per_day,
              driver,
              vehicle,
              carrier: carrier.url,
            })
              .then(onSaveSuccesfully)
              .catch((err) => err.response.json().then(this.handleServerError))
              .then(() => this.setState({ loading: false }))
        )
      )
      .catch((error) => console.error(error));
  }

  haveError(field) {
    const { fieldErrors } = this.state;
    return fieldErrors.indexOf(field) !== -1;
  }

  handleExceptionsDayClick(day, { disabled, workDay, exceptionDay }) {
    if (disabled) {
      return;
    }

    const { addedExceptions, exceptions } = this.state;

    this.setState({
      addedExceptions: [
        ...addedExceptions.filter((addedException) => !moment(day).isSame(addedException, 'day')),
      ].concat(workDay ? day : []),
      exceptions: [
        ...exceptions.filter((exception) => !exceptionDay || !moment(day).isSame(exception, 'day')),
      ],
    });
  }

  handleUpdateExceptionsClick() {
    const { onUpdateExceptionsClick } = this.props;

    const { addedExceptions, exceptions } = this.state;

    const finalExceptions = [...exceptions, ...addedExceptions].map((exception) =>
      moment(exception).format(requestDateFormat)
    );

    this.setState(
      {
        loading: true,
      },
      () => {
        onUpdateExceptionsClick(finalExceptions)
          .then(this.toggleModal('exceptionsModalOpened', false))
          .catch((err) => err.response.json().then(this.handleServerError))
          .then(() => this.setState({ loading: false }));
      }
    );
  }

  render() {
    const { show, onClose, intl, carrier, drivers, vehicles, contract } = this.props;

    const {
      startDateModalOpened,
      endDateModalOpened,
      exceptionsModalOpened,
      start_date,
      end_date,
      driver,
      vehicle,
      cost_per_day,
      loading,
      exceptions,
      addedExceptions,
      finishContractModalOpened,
      finishDaySelected,
    } = this.state;

    const t = intl.messages.components.ContractModal;
    const currency = intl.messages.currencies[carrier.currency];
    const dateFormats = intl.messages.date_formats;

    const isExceptionDayModifier = (day) => {
      return exceptions.filter((exception) => moment(exception).isSame(moment(day), 'day')).length;
    };
    const isAddedExceptionDayModifier = (day) =>
      addedExceptions.filter((exception) => moment(exception).isSame(moment(day), 'day')).length;
    const isWorkDayModifier = (day) => {
      return (
        moment(day).isSameOrAfter(contract.start_date, 'day') &&
        (!contract.end_date || moment(day).isSameOrBefore(contract.end_date, 'day')) &&
        !isExceptionDayModifier(day) &&
        !isAddedExceptionDayModifier(day)
      );
    };

    const getLastAllowedDayForChanges = () => {
      if (contract.last_freeze) {
        return moment(contract.last_freeze).toDate();
      }

      return moment(contract.start_date).toDate();
    };

    const exceptionsDisabledDays = [{ daysOfWeek: [0, 6] }].concat(
      contract && contract.start_date
        ? [
            {
              before: getLastAllowedDayForChanges(),
            },
          ].concat([
            {
              after: contract.end_date && moment(contract.end_date).toDate(),
            },
          ])
        : []
    );

    const endDateIsBeforeFreezeDate = () => {
      if (!contract.last_freeze) {
        return false;
      }
      return moment(contract.end_date).isBefore(moment(contract.last_freeze));
    };

    return (
      <div>
        <Modal
          show={show}
          size="M"
          onClose={onClose}
          headerComponent={
            <Fragment>
              {!contract ? (
                <div>
                  {t.title} {carrier.name}
                </div>
              ) : (
                <div>
                  {t.contract_title} {contract.vehicle.plate_number} |{' '}
                  {moment(contract.start_date).format(dateFormats.day_number_month_full)} -{' '}
                  {contract.end_date
                    ? moment(contract.end_date).format(dateFormats.day_number_month_full)
                    : t.end_date_undefined}
                </div>
              )}
            </Fragment>
          }
        >
          <Section>
            <SectionTitle>{t.start_date}</SectionTitle>
            {!contract ? (
              <ButtonGroup
                active={this.getStartDateValue()}
                onChange={this.handleStartDateChange}
                light
              >
                <Button value="today">{t.start_date_today}</Button>
                <Button value="tomorrow">{t.start_date_tomorrow}</Button>
                <Button value="other">{t.start_date_other}</Button>
              </ButtonGroup>
            ) : null}
            <div className={style.dateLiteral}>
              {moment((contract && contract.start_date) || start_date).format(
                dateFormats.week_day_month_name
              )}
            </div>
            {this.haveError('invalid_start_date') ? (
              <div className={style.error}>{t.invalid_start_date}</div>
            ) : null}
          </Section>
          <Section>
            <SectionTitle>{t.end_date}</SectionTitle>
            {!contract ? (
              <ButtonGroup
                active={this.getEndDateValue()}
                onChange={this.handleEndDateChange}
                light
              >
                <Button value={null}>{t.end_date_undefined}</Button>
                <Button value="defined">{t.end_date_defined}</Button>
              </ButtonGroup>
            ) : null}
            {end_date || (contract && contract.end_date) ? (
              <div className={style.dateLiteral}>
                {moment(end_date || contract.end_date).format(dateFormats.week_day_month_name)}
              </div>
            ) : contract ? (
              t.end_date_undefined
            ) : null}
          </Section>
          <Section>
            <SectionTitle>{t.vehicle}</SectionTitle>
            {!contract ? (
              <div>
                <Select
                  placeholder={t.vehicle_placeholder}
                  ignoreCase={true}
                  matchPos="any"
                  noResultsText={t.vehicle_not_found}
                  value={vehicle}
                  options={vehicles.map((vehicle) => ({
                    value: vehicle.url,
                    label: vehicle.plate_number,
                  }))}
                  onChange={this.handleChange('vehicle')}
                  clearable={false}
                  small
                  mandatory
                  error={this.haveError('vehicle') || this.haveError('existing_contracts')}
                />
                {this.haveError('existing_contracts') ? (
                  <div className={style.error}>{t.existing_contract_vehicle}</div>
                ) : null}
              </div>
            ) : (
              <div>{contract.vehicle.plate_number}</div>
            )}
          </Section>
          <Section>
            <SectionTitle>{t.driver}</SectionTitle>
            {!contract ? (
              <div>
                <Select
                  placeholder={t.driver_placeholder}
                  ignoreCase={true}
                  matchPos="any"
                  noResultsText={t.driver_not_found}
                  value={driver}
                  options={drivers
                    .filter((driver) => driver.is_active)
                    .map((driver) => ({
                      value: driver.url,
                      label: driver.contact_name,
                    }))}
                  onChange={this.handleChange('driver')}
                  clearable={false}
                  small
                  mandatory
                  error={this.haveError('driver') || this.haveError('existing_contracts')}
                />
                {this.haveError('existing_contracts') ? (
                  <div className={style.error}>{t.existing_contract_driver}</div>
                ) : null}
              </div>
            ) : (
              <div>{contract.driver.contact_name}</div>
            )}
          </Section>
          <Section className={style.costContainer}>
            <SectionTitle>{t.cost_per_day}</SectionTitle>
            {!contract ? (
              <Input
                helpText={currency}
                className={style.costInput}
                value={cost_per_day}
                onChange={this.handleChange('cost_per_day')}
                mandatory
                error={this.haveError('cost_per_day') ? t.missing : ''}
                type="number"
              />
            ) : (
              <div>
                <FormatPrice value={contract.cost_per_day} currency={carrier.currency} />
              </div>
            )}
          </Section>
          {contract ? (
            <Section>
              <SectionTitle>{t.exceptions}</SectionTitle>
              {!endDateIsBeforeFreezeDate() ? (
                <Button fullWidth onClick={this.toggleModal('exceptionsModalOpened', true)} link>
                  {t.exceptions_add}
                </Button>
              ) : null}
              <div className={style.exceptionsList}>
                {contract.exceptions.length ? (
                  contract.exceptions.map((exception, key) => (
                    <div key={key}>
                      {moment(exception).format(dateFormats.week_day_abbr_month_name)}
                    </div>
                  ))
                ) : (
                  <div>{t.no_exceptions}</div>
                )}
              </div>
            </Section>
          ) : null}
          {!contract ? (
            <Button fullWidth onClick={this.handleSave} primary disabled={loading}>
              {t.save}
            </Button>
          ) : (
            <div>
              {!endDateIsBeforeFreezeDate() ? (
                <Button
                  fullWidth
                  onClick={this.toggleModal('finishContractModalOpened', true)}
                  className={style.deleteButton}
                >
                  {t.finish}
                </Button>
              ) : null}
              <Button fullWidth onClick={onClose} neutral>
                {t.back}
              </Button>
            </div>
          )}
        </Modal>
        {startDateModalOpened ? (
          <Modal
            show
            withPadding={false}
            headerComponent={t.start_date_modal_title}
            onClose={this.toggleModal('startDateModalOpened', false)}
            size="M"
          >
            <Flexer.Parent justifyContent="center">
              <Calendar
                show={true}
                disablePast={false}
                fromMonth={false}
                locale={intl.locale}
                onDayClick={this.handleStartDayClick}
                disabledDays={[{ daysOfWeek: [0, 6] }]}
              />
            </Flexer.Parent>
          </Modal>
        ) : null}
        {endDateModalOpened ? (
          <Modal
            show
            withPadding={false}
            headerComponent={t.end_date_modal_title}
            onClose={this.toggleModal('endDateModalOpened', false)}
            size="M"
          >
            <Flexer.Parent justifyContent="center">
              <Calendar
                locale={intl.locale}
                renderDay={(day) => <span>{day.getDate()}</span>}
                onDayClick={this.handleEndDayClick}
                initialMonth={start_date ? moment(start_date).toDate() : null}
                fromMonth={start_date ? moment(start_date).toDate() : null}
                disabledDays={[{ daysOfWeek: [0, 6] }].concat(
                  start_date
                    ? [
                        {
                          before: moment(start_date).toDate(),
                        },
                      ]
                    : []
                )}
              />
            </Flexer.Parent>
          </Modal>
        ) : null}
        {finishContractModalOpened ? (
          <Modal
            show
            withPadding={false}
            headerComponent={t.finish_modal_title}
            onClose={this.toggleModal('finishContractModalOpened', false)}
            size="M"
          >
            <Flexer.Parent justifyContent="center">
              <Calendar
                locale={intl.locale}
                onDayClick={this.handleFinishContractDayClick}
                initialMonth={contract.start_date ? moment(contract.start_date).toDate() : null}
                fromMonth={contract.start_date ? moment(contract.start_date).toDate() : null}
                disabledDays={[{ daysOfWeek: [0, 6] }].concat(
                  contract.start_date
                    ? [
                        {
                          before: getLastAllowedDayForChanges(),
                        },
                      ]
                    : []
                )}
                selectedDays={finishDaySelected ? [finishDaySelected] : null}
                modifiers={{
                  workDay: isWorkDayModifier,
                  exceptionDay: isExceptionDayModifier,
                  weekendDays: [{ daysOfWeek: [0, 6] }],
                }}
              />
            </Flexer.Parent>
            <Button primary fullWidth disabled={loading} onClick={this.handleFinishContractClick}>
              {t.finish}
            </Button>
          </Modal>
        ) : null}

        {contract && exceptionsModalOpened ? (
          <Modal
            show
            withPadding={false}
            headerComponent={t.exceptions_add}
            onClose={this.toggleModal('exceptionsModalOpened', false)}
            size="M"
            onTop
          >
            <Flexer.Parent justifyContent="center">
              <Calendar
                locale={intl.locale}
                onDayClick={this.handleExceptionsDayClick}
                fromMonth={moment(contract.start_date).toDate()}
                toMonth={contract.end_date && moment(contract.end_date).toDate()}
                initialMonth={contract.start_date ? moment(contract.start_date).toDate() : null}
                disabledDays={exceptionsDisabledDays}
                modifiers={{
                  workDay: isWorkDayModifier,
                  exceptionDay: isExceptionDayModifier,
                  addedExceptionDay: isAddedExceptionDayModifier,
                  weekendDays: [{ daysOfWeek: [0, 6] }],
                }}
              />
            </Flexer.Parent>
            {this.haveError('wrong_date_journeys') ? (
              <div className={style.errorBottom}>{t.wrong_date_journeys}</div>
            ) : null}
            <Button primary fullWidth disabled={loading} onClick={this.handleUpdateExceptionsClick}>
              {t.save_exceptions}
            </Button>
          </Modal>
        ) : null}
      </div>
    );
  }
}

export default injectIntl(ContractModal);
